import { ImageAspectRatio } from 'domain/constants/imageAspectRatio';

export const imageAspectRatioPercentage = (ratio: ImageAspectRatio | undefined) => {
  if (ratio == null) {
    return '56.25%';
  }
  const map: { [key in ImageAspectRatio]: number } = {
    [ImageAspectRatio.W16H9]: 56.25,
    [ImageAspectRatio.W4H3]: 75,
    [ImageAspectRatio.W1H1]: 100,
    [ImageAspectRatio.W32H9]: 28.125,
    [ImageAspectRatio.W64H9]: 14.0625,
    [ImageAspectRatio.W3H4]: 133.3333,
    [ImageAspectRatio.W9H16]: 177.7778,
    [ImageAspectRatio.W9H32]: 355.5556,
  };
  return `${map[ratio] ?? 56.25}%`;
};
